import { useQuery } from "@tanstack/react-query";
import { BookOpen } from "lucide-react";
import { listStrategies } from "../api/strategies";
import Card from "../components/Card";
import Chip from "../components/Chip";
import EmptyState from "../components/EmptyState";
import Skeleton from "../components/Skeleton";

export default function StrategiesPage() {
  const { data: strategies, isLoading } = useQuery({
    queryKey: ["strategies"],
    queryFn: listStrategies,
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-fg">Strategy catalog</h1>
        <p className="text-sm text-muted mt-0.5">
          Read-only view. Strategies live in the repo; the UI never exposes their source.
        </p>
      </div>

      {isLoading && (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-40" />
          ))}
        </div>
      )}

      {!isLoading && (!strategies || strategies.length === 0) && (
        <Card>
          <EmptyState
            icon={<BookOpen size={32} />}
            title="No strategies visible to you"
            message="Ask an admin to grant access to strategies in the catalog."
          />
        </Card>
      )}

      {strategies && strategies.length > 0 && (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {strategies.map((s) => (
            <Card
              key={s.key}
              title={
                <span className="flex items-center gap-2">
                  <BookOpen size={14} className="text-brand-500" />
                  {s.display_name}
                </span>
              }
              subtitle={<span className="font-mono">{s.key}</span>}
            >
              <p className="text-sm text-fg-subtle min-h-[3rem]">{s.description}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {s.supported_modes.map((m) => (
                  <Chip key={m} tone={m === "live" ? "warn" : "info"} mono>
                    {m}
                  </Chip>
                ))}
                {s.supported_instruments.map((inst) => (
                  <Chip key={inst} mono>
                    {inst}
                  </Chip>
                ))}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
